<template>
    <div class="page">
        <div class="row">
            <div class="sm-12">
                <h2 class="button grey">Segunda Via do Boleto</h2>
            </div>
        </div>
        <div class="row" v-if="loading">
            <div class="sm-12">
                <p class="text-center">
                    <i class="mdi mdi-spin mdi-loading mdi-48px"></i>
                </p>
            </div>
        </div>
        <div class="row" v-else-if="!boleto">
            <div class="sm-12">
                <p class="text-center">Boleto não encontrado.</p>
            </div>
        </div>
        <div v-else>
            <div class="row">
                <div class="sm-12">
                    <p v-if="relacao.sistema=='C'">CONDOMÍNIO</p>
                    <p v-if="relacao.sistema=='A'">IMÓVEL</p>

                    <div class="flex bg-light-grey rounded mb-4 mobile-column">
                        <div
                            class="flex flex-column flex-centered col bg-grey p-16 mobile-full"
                            style="flex-basis: 0%;min-width:100px"
                        >
                            <small class="color-primary mb-4">Unidade</small>
                            <small>
                                <strong
                                    v-if="boleto && boleto.unidade"
                                >{{ boleto.unidade.descricao }}</strong>
                                <strong
                                    v-else-if="boleto && boleto.imovel"
                                >{{ boleto.imovel.codigo }}</strong>
                            </small>
                        </div>
                        <div class="flex flex-column flex-between p-16 w-100">
                            <div class="row">
                                <div class="sm-12 text-center">
                                    <small
                                        v-if="boleto && boleto.unidade"
                                    >{{ boleto.unidade.condominio.endereco.enderecoCompleto}}</small>
                                    <small
                                        v-if="boleto && boleto.imovel"
                                    >{{ boleto.imovel.endereco.enderecoCompleto}}</small>
                                </div>
                            </div>
                            <div class="row">
                                <div class="sm-6 md-3">
                                    <small class="flex flex-column flex-centered mt-16">
                                        <span class="color-primary">Vencimento</span>
                                        <span>{{ boleto.dataVencimento | date('dd/LL/yyyy') }}</span>
                                    </small>
                                </div>
                                <div class="sm-6 md-3">
                                    <small class="flex flex-column flex-centered mt-16">
                                        <span class="color-primary">Valor</span>
                                        <span>{{ boleto.valorAtualizado | number_format }}</span>
                                    </small>
                                </div>
                                <div class="sm-6 md-3">
                                    <small class="flex flex-column flex-centered mt-16">
                                        <span class="color-primary">Mês</span>
                                        <span>{{ boleto.competencia }}</span>
                                    </small>
                                </div>
                                <div class="sm-6 md-3">
                                    <small class="flex flex-column flex-centered mt-16">
                                        <span class="color-primary">Tipo Doc</span>
                                        <span>{{ boleto.tipoDOC }}</span>
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="sm-12 md-4">
                    <input type="date" lang="pt" v-model="data" v-if="boleto.atualizarVencimento" :min="hoje" />
                </div>
                <div class="sm-12 md-4">
                        <download-link
                        :href="url"
                        @click="verificaData"
                        target="_system" 
                        class="button primary"
                    >BAIXAR BOLETO</download-link>
                    <!--
                    <a class="button primary" @click="downloadBoleto(url)">BAIXAR BOLETOs</a>
                    -->
                </div>
                <div class="sm-12 md-4">
                    <button class="button secondary" v-if="sending">ENVIANDO...</button>
                    <button class="button secondary" v-else @click="enviarEmail">ENVIAR POR E-MAIL</button>
                </div>
            </div>

            <div class="row">
                <div class="sm-12">
                    <p v-if="constantes.SEGUNDA_VIA_AVISO_TEMPO_PAGAMENTO">
                        <small>
                            <i v-html="constantes.SEGUNDA_VIA_AVISO_TEMPO_PAGAMENTO"></i>
                        </small>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { DateTime } from "luxon";
import api from "/plugins/api";
import Swal from "sweetalert2";
import qs from "qs";
import { Datetime } from "vue-datetime";
import { saveAs } from 'file-saver';
import { api_endpoint } from "~/plugins/api";

export default {
    data() {
        return {
            loading: false,
            sending: false,
            errors: [],
            data: DateTime.local().toFormat("yyyy-LL-dd"),
            hoje: DateTime.local().toFormat("yyyy-LL-dd"),
            boleto: null,
            constantes: {}
        };
    },
    filters: {
        number_format(value) {
            return new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL"
            }).format(value);
        }
    },
    computed: {
        cliente() {
            return this.$store.state.cliente;
        },
        codigo() {
            return +this.$route.params.codigo;
        },
        mes() {
            return this.$route.params.mes;
        },
        ano() {
            return this.$route.params.ano;
        },
        relacao() {
            return this.$store.getters.relacao;
        },
        condominio() {
            return this.$store.getters.condominio;
        },
        imovel() {
            return this.$store.getters.imovel;
        },
        jwt() {
            return this.$store.state.jwt;
        },
        maior_dia_util() {
            let vencimento = DateTime.fromSQL(this.boleto.dataVencimento);
            let dias_mes = vencimento.daysInMonth;
            let ultimo_dia_mes = DateTime.fromSQL(
                vencimento.toFormat(`yyyy-LL-${dias_mes}`)
            );

            let subtrair = 0;
            if (ultimo_dia_mes.weekday == 1) {
                subtrair = 2;
            } else if (ultimo_dia_mes == 7) {
                subtrair = 1;
            }
            if (subtrair > 0) {
                ultimo_dia_mes.plus({
                    days: -subtrair
                });
            }
            return ultimo_dia_mes.toFormat("yyyy-LL-dd");
        },
        url() {
            let tipo = this.relacao.sistema == "C" ? "condominio" : "aluguel";
            let tipo_relacao = this.relacao.tipoRelacao;

            let query = {
                jwt: this.jwt,
                atualizarVencimento: this.boleto.atualizarVencimento
            };
            if (this.data != this.boleto.dataVencimento) {
                query.data_vencimento = this.data;
            }
            query = qs.stringify(query);

            //let endpoint = `${location.origin}${location.pathname}api`;
            let endpoint = api_endpoint
            if (location.origin == "file://" || 'undefined' != typeof window.cordova) {
                endpoint = window.api_endpoint;
            }

            return `${endpoint}/boletos/${tipo}/${tipo_relacao}/${this.codigo}?${query}`;
        }
    },
    methods: {
        async downloadBoleto(url) {
            saveAs(url, 'boleto.pdf');
        },
        async loadConstantes() {
            let { data } = await api.get('/constantes')
            this.constantes = data.reduce((acc, row) => {
                acc[row.chave] = row.valor;
                return acc;
            }, {});
        },
        async loadBoleto() {
            try {
                let params = {};
                params.mes = this.mes;
                params.ano = this.ano;
                if (this.condominio) {
                    params.codigo_condominio = +this.condominio.codigo;
                }
                if (this.imovel) {
                    params.codigo_imovel = +this.imovel.codigo;
                }
                params.tipo_sistema = this.relacao.sistema;
                params.tipo_relacao = this.relacao.tipoRelacao;
                this.boletos = [];
                let { data: boletos } = await api.get("boletos", {
                    params
                });

                if (boletos && !(boletos instanceof Array)) {
                    boletos = [boletos];
                }
                let boleto = boletos.find(
                    ({ codigo }) => codigo == this.codigo
                );

                this.boleto = boleto;
            } catch (err) {
                console.error(err);
                this.error = [...this.error, err];
            }
        },
        async loadData() {
            this.loading = true;
            this.errors = [];
            await this.loadBoleto();
            this.loadConstantes();
            this.loading = false;
        },
        async verificaData(e) {
            try {
                if (this.data < this.hoje || this.data > this.maior_dia_util) {
                    let hoje = DateTime.fromSQL(this.hoje).toFormat(
                        "dd/LL/yyyy"
                    );
                    let ultimo = DateTime.fromSQL(this.maior_dia_util).toFormat(
                        "dd/LL/yyyy"
                    );
                    if (hoje > ultimo) {
                        hoje = DateTime.fromSQL(this.maior_dia_util).toFormat(
                            "01/LL/yyyy"
                        );
                    }
                    /*
                    throw new Error(
                        `A data de vencimento do seu boleto,\ndeve ser entre ${hoje} e ${ultimo}`
                    );
                    */
                }

                if (this.data != this.boleto.dataVencimento) {
                    if (
                        !confirm(
                            "=====TELA DE CONFIRMAÇÃO=====\n\nCaso você confirme a atualização da\ndata de vencimento do seu boleto, o\nmesmo vai ser atualizado.\n\nEsta alteração poderá gerar multas,\n juros e encargos.\n\nConfirmar atualização?"
                        )
                    ) {
                        if (e) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                        return false;
                    }
                }

                return true;
            } catch (err) {
                Swal.fire({
                    icon: "error",
                    title: "Oops",
                    text: err.message
                });
                if (e) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            }
            return false;
        },
        async enviarEmail() {
            try {
                if (!this.verificaData()) {
                    return;
                }

                let tipo =
                    this.relacao.sistema == "C" ? "condominio" : "aluguel";
                let tipo_relacao = this.relacao.tipoRelacao;

                let params = {};
                if (this.data != this.boleto.dataVencimento) {
                    params.data_vencimento = this.data;
                }

                this.sending = true;
                let { data } = await api.post(
                    `boletos/${tipo}/${tipo_relacao}/${this.codigo}`,
                    params
                );
                Swal.fire({
                    icon: "success",
                    title: "Sucesso",
                    text: `Boleto enviado para o e-mail: ${this.cliente.contato.email}`
                });
            } catch (err) {
                if (err.response && err.response.data) {
                    Swal.fire({
                        icon: "error",
                        title: "Oops",
                        text: err.response.data.error
                    });
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Oops",
                        text: "Não foi possível enviar o boleto"
                    });
                }
                console.error(err);
            }
            this.sending = false;
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                this.loadData();
            }
        }
    }
};
</script>
<style lang="less">
@import "../../../css/colors.less";
input[type="date"] {
    margin-top: 0.5em;
}
hr {
    border: 0;
    border-bottom: 1px solid var(--grey);
}
.w-100 {
    width: 100%;
}
.color-primary {
    color: var(--primary);
}
.p-16 {
    padding: 16px;
}
.mb-4 {
    margin-bottom: 4px;
}
.mt-16 {
    margin-top: 16px;
}
.mb-16 {
    margin-bottom: 16px;
}
.rounded {
    border-radius: 0.25em;
    overflow: hidden;
}
.bg-grey {
    background-color: var(--grey);
}
.bg-light-grey {
    background-color: var(--light-grey);
}
.flex {
    .col {
        width: 25%;
        min-width: 75px;
    }
}
small {
    span {
        font-size: inherit;
    }
}
</style>